module.exports = __webpack_public_path__ + "img/pic_NewTaipeiCity.d3d8aa54.jpg";